import './libraries/stylesheets'
import './libraries/scripts'

import Vue from 'vue'
import axios from './axios'
import App from './App.vue'
import getRouter from './router'
import store from './store/store'
import Meta from 'vue-meta'
import { i18n } from './locale'
import loading from 'vuejs-loading-screen'
import VueToastr from '@deveodk/vue-toastr'
import VueSweetalert2 from 'vue-sweetalert2'
import VCharts from 'v-charts'
import cashhero from './plugins/cashhero'
import HighchartsVue from 'highcharts-vue'
import vueNumeralFilterInstaller from 'vue-numeral-filter'
import Multiselect from 'vue-multiselect'
import XBackend from 'x-backend'
import Permissions, { copyPermission } from './permissions'
import DatePicker from 'vue2-datepicker'
import VueViewer from 'v-viewer'
import FloatingVue from 'floating-vue'

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$base_api = process.env.VUE_APP_API
Vue.prototype.$Permissions = Permissions
Vue.prototype.$token = process.env.VUE_APP_TOKEN

Vue.use(Meta)
Vue.use(loading)
Vue.use(VueSweetalert2)
Vue.use(VCharts)
Vue.use(cashhero)
Vue.use(HighchartsVue)
Vue.use(vueNumeralFilterInstaller, { locale: 'en-gb' })
Vue.use(XBackend)
Vue.use(DatePicker)
Vue.use(VueViewer)
Vue.use(FloatingVue)

// vue moment js
const moment = require('moment')
require('moment/locale/en-au')
Vue.use(require('vue-moment'), {
  moment
})

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 6000
})

// register globally
Vue.component('multiselect', Multiselect)

Object.defineProperty(window, 'permission', {
  get: copyPermission
})

new Vue({
  router: getRouter(store),
  store,
  i18n,
  render: (h) => {
    return h(App)
  }
}).$mount('#app')
